import { useState, useEffect } from 'react';
import AiAgentService from '../../../api/AiAgentService';
import { VALIDATION_MESSAGES } from '../constants';

const useAgentConfigs = () => {
    const [agentConfigs, setAgentConfigs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchAgentConfigs = async () => {
        try {
            setLoading(true);
            const response = await AiAgentService.getListOfAgentConfigs();
            setAgentConfigs(response);
            setError(null);
        } catch (err) {
            console.error('Помилка завантаження конфігурацій агентів:', err);
            setError(VALIDATION_MESSAGES.LOAD_ERROR);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const createAgentConfig = async (configData) => {
        try {
            const response = await AiAgentService.createAgentConfig(configData);
            setAgentConfigs(prev => [...prev, response]);
            return response;
        } catch (error) {
            console.error('Помилка створення конфігурації:', error);
            throw error;
        }
    };

    const updateAgentConfig = async (newRow) => {
        try {
            const config = agentConfigs.find(c => c.id === newRow.id);
            if (config && (config.id === 1 || config.name === 'default')) {
                // Для default конфігурації не дозволяємо змінювати name
                newRow.name = config.name;
            }

            await AiAgentService.updateAgentConfig(newRow);
            setAgentConfigs(prev => prev.map(config => 
                config.id === newRow.id ? newRow : config
            ));
            return newRow;
        } catch (error) {
            console.error('Помилка оновлення конфігурації:', error);
            throw error;
        }
    };

    const deleteAgentConfig = async (configId) => {
        try {
            await AiAgentService.deleteAgentConfig(configId);
            setAgentConfigs(prev => prev.filter(config => config.id !== configId));
        } catch (error) {
            console.error('Помилка видалення конфігурації:', error);
            throw error;
        }
    };

    const canDeleteConfig = (configId) => {
        const config = agentConfigs.find(c => c.id === configId);
        return !(config && (config.id === 1 || config.name === 'default'));
    };

    useEffect(() => {
        fetchAgentConfigs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        agentConfigs,
        loading,
        error,
        fetchAgentConfigs,
        createAgentConfig,
        updateAgentConfig,
        deleteAgentConfig,
        canDeleteConfig
    };
};

export default useAgentConfigs;
